import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Box, Typography, IconButton, Paper, InputBase, Card, Grid, CardContent } from '@mui/material';
import { Search, Upload, Add, FilterList, UploadOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { styled } from '@mui/material/styles';
import api from '../../utils/api';
import UserHeader from '../../component/reusable/UserHeader';
import Cards from '../../component/reusable/Cards';
import AllBomOrderTable from '../../component/bomComps/AllBomOrderTable';
import { setSubcategoryRefresh } from '../../redux/subcategories/getAllSubcategorySlice';
import AllScheduleOrderTable from '../../component/scheduleComps/AllScheduleOrderTable';
import { getAllScheduleOrders, getScheduleOrdersStatistics, setFilterValues, setScheduleOrderFromDate, setScheduleOrderPage, setScheduleOrderTab, setScheduleOrderToDate, setScheduleSearch } from '../../redux/scheduledOrders';
import { Card1, Card2, Card3, Card4 } from '../../Svg';
import ScheduleOrderTabs from '../../component/scheduleComps/scheduleList/ScheduleOrderTab';
import ScheduleOrderFilter from '../../component/scheduleComps/scheduleList/ScheduleOrderFilter';

const SearchInput = styled(Paper)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    borderRadius: '8px',
    boxShadow: 'none',
    border: `1px solid ${theme.palette.divider}`,
    width: '320px',
    margin: "20px 0px",
    fontFamily: `'Public Sans', sans-serif`,
}));

function ScheduleOrders() {
    const [statuss, setStatus] = useState("");
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [limit, setLimit] = useState(25)
    const [sortBy, setSortyBy] = useState('createdAt');
    const [order, setOrder] = useState('dsc')
    const [allStatus, setAllStatus] = useState('')

    const { scheduleOrders, scheduleOrdertatistics, search, page, loading, refresh, fromDate, toDate, selectedTab } = useSelector((state) => state.scheduleorder)

    const scheduleData = scheduleOrders?.data
    const totalPages = scheduleOrders?.totalPages
    const totalItems = scheduleOrders?.totalItems
    const itemsPerPage = scheduleOrders?.limit

    console.log(scheduleOrders);


    const start = (page - 1) * limit + 1;
    const end =
        totalPages === page
            ? totalItems
            : (page - 1) * limit + limit;



    const status = (selectedTab === 0 ? allStatus : selectedTab == 1 ? 'PENDING' : selectedTab == 2 ? 'AWAITING' : selectedTab == 3 ? 'RESCHEDULE' : selectedTab == 4 ? 'COMPLETED' : 'CANCELLED')

    console.log(status,selectedTab);
    
    useEffect(() => {
        dispatch(getAllScheduleOrders(`?search=${search}&page=${page}&status=${status}&fromDate=${fromDate}&toDate=${toDate}&sortBy=${sortBy}&order=${order}`));
    }, [page, search, status, limit, refresh, sortBy, order, fromDate, toDate,selectedTab]);

    useEffect(() => {
        // dispatch(getAllScheduleOrders(filters))
        dispatch(getScheduleOrdersStatistics())
    }, [])

    console.log(selectedTab);



    const statuses = [
        {
            title: 'New',
            count: scheduleOrdertatistics?.data?.APPROVED?.totalCount || 0,
            today: `+${scheduleOrdertatistics?.data?.APPROVED?.todaysOrderCount || 0} today`,
            icon: <Card1 />,
        },
        {
            title: 'Reschedule  ',
            count: scheduleOrdertatistics?.data?.RESCHEDULE?.totalCount || 0,
            today: `+${scheduleOrdertatistics?.data?.RESCHEDULE?.todaysOrderCount || 0} today`,
            icon: <Card2 />,
        },
        {
            title: 'Awaiting',
            count: scheduleOrdertatistics?.data?.AWAITING?.totalCount || 0,
            today: `+${scheduleOrdertatistics?.data?.AWAITING?.todaysOrderCount || 0} today`,
            icon: <Card3 />,
        },
        {
            title: 'Completed',
            count: scheduleOrdertatistics?.data?.COMPLETED?.totalCount || 0,
            today: `+${scheduleOrdertatistics?.data?.COMPLETED?.todaysOrderCount || 0} today`,
            icon: <Card4 />,
        },
    ];



    const handleChange = (event, newValue) => {
        console.log(newValue);
        
        dispatch(setScheduleOrderTab(newValue));
        setAllStatus('')
        dispatch(setScheduleOrderPage(1))
        dispatch(setScheduleSearch(''))
        dispatch(setScheduleOrderFromDate(''))
        dispatch(setScheduleOrderToDate(''))
    };

    const handleFileChange = async (e) => {
        try {
            const file = e.target.files[0];
            if (!file) return;

            const formData = new FormData();
            formData.append('file', file);

            const response = await api.addBulksubCategory(formData);
            if (response.data) {
                console.log(response.data);
                toast.success(response?.data?.data?.message)
                dispatch(setSubcategoryRefresh());
            }
        } catch (err) {
            console.log(err);
            toast.error(err?.response?.data?.message || 'Something went wrong')
        }
    };

    const handleOpenMenu = (sort) => {
        setSortyBy(sort)
        setOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    };


    return (
        <>
            <UserHeader
                index="Schedule Order"
                root="Dashboard"
                setStatus={setStatus}
                setSearch={setScheduleSearch}
                handleFileChange={handleFileChange}
                hideadd={'hide'}
            />
            <Box sx={{ paddingBottom: '16px' }}>
                <Grid container spacing={2}>
                    {statuses.map((status, index) => (
                        <Grid item xs={12} sm={6} md={3} key={index}>
                            <Card sx={{
                                display: 'flex', alignItems: 'flex-start', boxShadow: "none",
                                justifyContent: 'space-between', border: '1px solid #E0E2E7',
                            }}>
                                <CardContent>
                                    <Typography variant="subtitle1" color="#777980" fontSize="16px">
                                        {status.title}
                                    </Typography>
                                    <Typography variant="h5" color="#1D1F2C" sx={{ p: '6px 0' }} fontSize="28px">
                                        {status.count}
                                    </Typography>
                                    <Typography variant="body2" color="#858D9D" fontSize="14px">
                                        {status.today}
                                    </Typography>
                                </CardContent>
                                <Box sx={{ p: 2 }}>{status.icon}</Box>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
            <Box>

                <ScheduleOrderTabs handleChange={handleChange} selectedTab={selectedTab} />
                 <ScheduleOrderFilter setAllStatus={setAllStatus} search={search} selectedTab={selectedTab} />
                <Box mt={2}>
                    {
                        loading ?
                            <div style={{ display: 'flex', justifyContent: 'center' }}>Loading...</div>
                            :
                            <>
                                {scheduleData?.length > 0 ?
                                    <Typography>
                                        <AllScheduleOrderTable
                                            scheduleData={scheduleData}
                                            page={page}
                                            setPage={setScheduleOrderPage}
                                            itemsPerPage={itemsPerPage}
                                            totalItems={totalItems}
                                            totalPages={totalPages}
                                            start={start}
                                            end={end}
                                            handleOpenMenu={handleOpenMenu}
                                        />
                                    </Typography>
                                    :
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        No Data found
                                    </div>
                                }
                            </>
                    }

                </Box>
            </Box>
        </>
    );
}

export default ScheduleOrders;
